<template>
  <div class="break_main">
    <head-top head-title="审核管理" go-back="true"></head-top>
    <!--<div class="back" @click="back"></div>-->
    <ol>
      <li>
        <router-link to="/ToExamine" replace>
          <div>
            <span>管理员审核</span>
          </div>
        </router-link>
      </li>
      <li>
        <router-link to="/MyRecord" replace>
          <div>
            <span>我的发起记录</span>
          </div>
        </router-link>
      </li>
    </ol>
    <!--显示子路由内容部分-->
    <router-view></router-view>
  </div>
</template>
<style lang="scss">
  .break_main {
    width: 100%;
    padding-top: 40px;
    background: #fff;
    position: relative;
    .back {
      width: 42px;
      height: 42px;
      line-height: 42px;
      opacity: 0;
      z-index: 667;
      position: absolute;
      top: 0;
      left: 0;
    }
    ol {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid #d7d7d7;
      list-style: none;
      background: #fff;
      right: 0;
      left: 0;
      position: fixed;
      z-index: 666;
      li {
        /*width: 32.2%;*/
        width: 48.5%;
        float: left;
        height: 50px;
        text-align: center;
        margin-left: 2px;
        border-right: 1px solid #d7d7d7;
        a {
          width: 100%;
          color: #000000;
          font-size: 15px;
          font-weight: bolder;
          text-align: center;
          text-decoration: none;
          div {
            height: 48px;
            span {
              line-height: 50px;
            }
          }
        }
        a.active {
          color: #0078de;
          font-size: 15px;
          font-weight: bolder;
          text-align: center;
          div {
            border-bottom: 3px solid #0078de;
          }
        }
      }
      li:first-child {
        border-left: none;
      }
      li:last-child {
        border-right: none;
      }
    }
  }
</style>
<script>
  import headTop from '../../components/header/Header.vue'

  export default {
    data () {
      return {}
    },
    methods: {
      // back () {
      //   // this.$router.push('/TeamList')
      //   this.$router.push('/home/PunchClock')
      // }
    },
    components: {
      headTop
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/content/Looked.vue